import { Link } from 'react-router-dom';
import { UserCircle } from 'lucide-react';
import { useSelector } from 'react-redux';
import { selectUserDetails } from '../../store/slices/userSlice';
import { useState, useRef, useEffect } from 'react';

const ProfileCircle = () => {
  const userDetails = useSelector(selectUserDetails);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const subscriptionStatus = userDetails.subscription_status;

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const menuItems = [
    { path: '/account', label: 'Profile' },
    ...(userDetails?.affiliate_id ? [{ path: '/AffiliateDashboard', label: 'Affiliate Dashboard' }] : [])
    // ...(subscriptionStatus !== 'free' && subscriptionStatus !== 'premium_trial'
    //   ? [{ path: '/cancel-subscription', label: 'Cancel Subscription' }]
    //   : [])
  ];

  return (
    <div className="relative" ref={dropdownRef}>
      <div className="flex items-center justify-center cursor-pointer" onMouseEnter={() => setIsDropdownOpen(true)}>
        <Link to="/account" className="flex items-center justify-center">
          <div className="w-10 h-10 rounded-full bg-purple-100 hover:bg-purple-200 flex items-center justify-center transition-colors">
            {userDetails?.profile_photo_url ? (
              <img
                src={userDetails.profile_photo_url}
                alt="Profile"
                className="w-full h-full rounded-full object-cover"
                onError={(e) => {
                  e.currentTarget.src = '/default-avatar.png';
                }}
              />
            ) : (
              <UserCircle className="text-purple-800 w-full" />
            )}
          </div>
        </Link>
      </div>

      {/* Dropdown Menu */}
      {isDropdownOpen && (
        <div
          className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
          onMouseLeave={() => setIsDropdownOpen(false)}
        >
          <div className="py-1">
            {subscriptionStatus &&
              menuItems.map(({ path, label }) => (
                <Link key={path} to={path} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                  {label}
                </Link>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileCircle;
